module.exports = __webpack_public_path__ + "img/10.506def8.png";